import { isValidTipoConta } from "./IsValidTipoConta";

export async function filtrarPlanoUsinasDisponiveisTipoPfPj({
  planoUsinas,
  tipoConta, // PJ ou PF
}) {
  if (planoUsinas.length < 1) {
    return [];
  }

  if (!isValidTipoConta(tipoConta)) {
    return [];
  }

  return planoUsinas.filter(
    (planoUsina) =>
      planoUsina.attributes?.[`consumo_minimo_kw_${tipoConta}`] != 0 // consumo precisa diferente de 0 - Habilitado
  );
}
